export enum SalutationEnum {
  ValidValue  = 'DF7A343C-3492-4A13-9315-1F2E733882F6',
  Mrs         = '0000000B-1000-0000-0000-000000000001',
  Ms          = '0000000B-1000-0000-0000-000000000002',
  Miss        = '0000000B-1000-0000-0000-000000000003',
  Mr          = '0000000B-1000-0000-0000-000000000004',
  Dr          = '0000000B-1000-0000-0000-000000000005',
  Prof        = '0000000B-1000-0000-0000-000000000006',
  Emperor     = '0000000B-1000-0000-0000-000000000007',
  Queen       = '0000000B-1000-0000-0000-000000000008'
}
